import React from 'react';
import { RouteProps, Route as ReactDOMRoute, Redirect } from 'react-router-dom';

import { useAuth } from '../hooks/AuthContext';

interface MyRouteProps extends RouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
}

// Rota é  privada e Usuario Autentincado = OK
// Rota é privada e Usuario NÃO Autentincado = Redirecionar para o Login
// Rota NÃO é privada e Usuario Autentincado = Redirecionar para o Dashboard
// Rota NÂO é privada e Usuario Autentincado = OK

const Route: React.FC<MyRouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!user ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? '/' : '/dashboard',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;
